<template>
  <v-container fluid class="pa-5" v-if="Object.keys(callList).length">
    <v-layout align-center justify-center my-2>
      <v-flex :md9="callList.type_id === 9" :md5="callList.type_id !== 3" class="headline">
        {{ callList.name }}
        <v-btn v-if=" callList.type_id !== 3 && canEditCallCenter"
          flat
          icon
          outline
          @click="callListModal = true">
          <v-icon small>
            fa fa-info
          </v-icon>
        </v-btn>
        <v-menu v-if="canEditCallCenter" offset-y>
          <v-chip
            small
            slot="activator"
            :class="call_color(callList.status)"
            class="white--text">
            <v-icon class="pr-2 x-small-icon" >{{call_icon(callList.status)}}</v-icon>
            {{call_name(callList.status)}}
          </v-chip>
          <v-list>
            <v-list-tile v-for="(item, index) in statusExclude(this.callList.status)"  :key="index" @click="updateStatus(item.value, callList)">
              <v-list-tile-title>{{item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-chip v-else-if="canSeeCampaign"
          offset-y
          small
          :class="call_color(callList.status)"
          class="white--text">
          <v-icon class="pr-2 x-small-icon">
            {{call_icon(callList.status)}}
          </v-icon>
          {{call_name(callList.status)}}
        </v-chip>
      </v-flex>
      <template v-if="callList.type_id !== 3">
        <v-flex md2 class="headline">
          <span>
            Clientes: {{callList.customers_total_qty || 0}}
          </span>
        </v-flex>
        <v-flex md2 class="headline">
          <span>
            Con gestión: {{callList.customers_scheduled_qty || 0}}
          </span>
        </v-flex>
      </template>
      <v-flex md3>
        <v-btn
          class="k-orange-linear white--text"
          block
          large
          v-if="showConnectButton"
          :disabled="!canMakeCall"
          @click="startCallCenterNew">
          Iniciar call center
        </v-btn>
        <span class="d-flex align-center">
          Llamadas en la cola: {{queueCallsQuantityToShow}}<div><v-icon class="ml-2 pa-2 cursor-pointer" small @click="reloadCallsQuantity">fa-refresh</v-icon></div>
        </span>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3 mb-4>
      <v-flex md4 pr-3>
        <v-text-field
          v-model="notificationSchedulesSearch"
          label="Buscar..."
          color="black"
          solo>
        </v-text-field>
      </v-flex>
      <v-flex md3 pr-3>
        <v-select
          v-model="filters.user_id"
          :items="usersList"
          class="white--text"
          color="grey"
          solo>
        </v-select>
      </v-flex>
      <v-flex md3 pr-3>
        <v-select
          v-model="filters.status"
          :items="statusesList"
          class="white--text"
          color="grey"
          solo>
        </v-select>
      </v-flex>
      <v-flex md2>
        <v-menu
          ref="DatepickerRef"
          :close-on-content-click="false"
          v-model="datePicker"
          :nudge-right="40"
          :return-value.sync="filters.date"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px">
        <v-text-field
          slot="activator"
          :value="formatDate(filters.date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
          prepend-icon="event"
          readonly
          solo/>
        <v-date-picker
          v-model="filters.date"
          @input="$refs.DatepickerRef.save(filters.date)"
          color="k-orange-linear"/>
        </v-menu>
      </v-flex>
    </v-layout>
    <data-table
      ref="notificationSchedules"
      url="notification_schedules_v2"
      :search="notificationSchedulesSearch"
      :filters="filters"
      @items-reload="notificationSchedules = $event">
      <template slot="content" v-for="(item, i) in notificationSchedules">
        <v-list-tile
          class="fixed"
          :key="`notificationSchedule-${item.id}`"
          @click="getNotificationSchedule(item.id)"
          avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>
              fas fa-user
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>
                {{ item.name || (`${item.first_name} ${(item.last_name ? item.last_name : '')}`) }}
              </strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ item.account }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <div class="text-xs-right">
            <span>
              {{ item.to }}
            </span>
            <br />
            <small>
              {{ formatDate(item.local_schedule_date, 'YYYY-MM-DD HH:mm:ss','h:mm A') }}
            </small>
          </div>
          <span :class="getSpanColor(item.status_id)">
            <v-icon small :class="getSpanColor(item.status_id, true)">
              {{ `fas fa-${showStatusIcon(item.status_id)}` || 'fas fa-report_off' }}
            </v-icon>
            {{ storeStatus(item.status_id).status  }}
          </span>
        </v-list-tile>
        <v-divider
          v-if="i !== notificationSchedules.length - 1"
          :key="`divider${i}`"/>
      </template>
    </data-table>
    <call-list-dialog
      :show="callListModal"
      :call-list="callList"
      @update="update"
      @close="callListModal = false"/>
    <notification-schedule-detail/>
    <call-center-dialog
      :show="callCenterModal"
      :call-list="callList"
      :disable-save-btn="disableSaveButton"
      @save="startCallCenter"
      @close="callCenterModal = false"/>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import _ from 'lodash';
import EventBus from '@/event-bus';
import filtersMixin from '@/mixins/workflowFilters';
import statusMixins from '@/mixins/status';
import callListMixin from '@/mixins/callList';
import DataTable from '@/components/global/DataTable2';
import CallListDialog from '@/components/CallList/Modal/Index';
import CallCenterDialog from '@/components/CallList/Detail/Modal';
import NotificationScheduleDetail from '@/components/notification_schedule/Detail';
import formatDateMixin from '@/mixins/formatDate';
import permissionsMixin from '@/mixins/permissions';

const mapStatusList = data => ([
  {
    text: `Estados (${(data || []).reduce((a, b) => a + parseInt(b.total, 10), 0)})`,
    value: '',
  },
  ...(data || []).map(item => ({
    text: `${item.status} (${item.total})`,
    value: item.value,
  })),
]);

const mapUsersList = data => ([
  {
    text: `Usuarios (${(data || []).reduce((a, b) => a + parseInt(b.amount, 10), 0)})`,
    value: '',
  },
  ...(data || []).map(item => ({
    text: `${item.first_name}${item.last_name ? ` ${item.last_name}` : ''} (${item.amount})`,
    value: item.user_id,
  })),
]);

const routerHandler = (to, from, next) => {
  if (!(to.params || {}).callList) return;
  
  const today = moment().format('YYYY-MM-DD'); 
  const routes = [
    filtersMixin.methods.findFilters(),
    Vue.axios.get(`calls_lists/${to.params.callList}`),
    // Vue.axios.get(`/notification_schedules/live_status?call_list_id=${to.params.callList}&channel=5&ignore_programmed=false&date=${today}`),
    // Vue.axios.get(`/call_center/users?call_list_id=${to.params.callList}&date=${today}`),
    Vue.axios.get(`/call_center/${to.params.callList}/queued_calls`, { timeout: 10000 }).catch(() => ({ data: 'Error' })),
    Vue.axios.get('check_release', { params: { name: 'call_list_queues' } }),
  ];
  Promise.all(routes).then((values) => {
    next((vm) => {
      vm.callList = values[1].data; // eslint-disable-line
      vm.filters.call_list_id = values[1].data.id; // eslint-disable-line
      // vm.statusesList = mapStatusList(values[2].data); // eslint-disable-line
      // vm.usersList = mapUsersList(values[3].data); // eslint-disable-line
      vm.queueCallsQuantity = values[2].data;
      vm.showConnectButton = !values[3].data.is_active;
    });
  }).catch(() => {});
};

export default {
  beforeRouteEnter: routerHandler,
  beforeRouteUpdate: routerHandler,
  components: {
    DataTable,
    CallListDialog,
    CallCenterDialog,
    NotificationScheduleDetail,
  },
  mixins: [
    statusMixins,
    callListMixin,
    formatDateMixin,
    callListMixin,
    permissionsMixin,
  ],
  data() {
    return {
      showConnectButton: false,
      registeringNewInfra: false,
      queueCallsQuantity: 0,
      disableSaveButton: false,
      callList: {},
      callListModal: false,
      callCenterModal: false,
      datePicker: false,
      filters: {
        channel: 5,
        type: 1,
        call_list_id: '',
        user_id: '',
        status: '',
        ignore_programmed: false,
        date: moment().format('YYYY-MM-DD'),
      },
      notificationSchedulesSearch: '',
      notificationSchedules: [],
      queueList: [
        {
          text: 'Grupo',
          value: '',
        },
      ],
      statusesList: [
        {
          text: 'Estados',
          value: '',
        },
      ],
      usersList: [
        {
          text: 'Usuarios',
          value: '',
        },
      ],
    };
  },
  computed: {
    queueCallsQuantityToShow() {
      if (this.queueCallsQuantity === 'Error') {
        return this.queueCallsQuantity;
      }

      return new Intl.NumberFormat('es-VE').format(this.queueCallsQuantity || 0);
    },
    ...mapGetters({
      storeStatus: 'status',
    }),
    canMakeCall() {
      return this.callList.status === 1 && !this.registeringNewInfra;
    },
    canEditCallCenter() {
      return this.checkPermissions([
        'edit_call_center',
      ]);
    },
    canSeeCampaign() {
      return this.checkPermissions([
        'see_campaign_call_center',
      ]);
    },
  },
  methods: {
    update(data) {
      this.callList = {
        ...this.callList,
        ...data,
      };
    },
    formatDate(date, firstFormat, dateFormat) {
      return moment(date, firstFormat).format(dateFormat);
    },
    getNotificationSchedule(id) {
      EventBus.$emit('showNotificationDetail', id);
    },
    startCallCenter(data) {
      this.disableSaveButton = true;
      const body = {
        call_list_id: this.callList.id,
        call_type: data.call_type,
        zoom_url: data.zoom_url,
        conference_id: data.conference_id,
        access_code: data.access_code,
        receive_incoming_calls: data.receive_incoming_calls,
        max_commitment_days: this.callList.max_commitment_days,
        extension_number: data.extension_number,
        new_server: data.new_server,
      };
      if (data.call_type === 'zoom') {
        this.$store.dispatch('dialer/startCallCenterZoom', body);
      } else if (data.call_type === 'predictive') {
        this.$store.dispatch('dialer/startCallCenterPredictive', body);
      } else {
        this.$store.dispatch('dialer/startCallCenterSoftphone', body);
      }
    },
    reloadStatus() {
      return;
      this.axios.get(`/notification_schedules/live_status?call_list_id=${this.callList.id}&channel=5&ignore_programmed=false&user_id=${this.filters.user_id}&date=${this.filters.date}`)
        .then((response) => {
          this.statusesList = mapStatusList(response.data);
        }).catch(() => {});
      this.axios.get(`/call_center/users?call_list_id=${this.callList.id}&date=${this.filters.date}`)
      .then((response) => {
        this.usersList = mapUsersList(response.data);
      }).catch(() => {});
    },
    reloadCallsQuantity() {
      return this.axios.get(`/call_center/${this.callList.id}/queued_calls`)
        .then(({ data }) => {
          this.queueCallsQuantity = data;
        }).catch(() => {
          this.queueCallsQuantity = 'Error';
        });
    },
    // CHANGE_HERE_VOICEMAIL
    async startCallCenterNew() {
      this.registeringNewInfra = true;

      // const [ result, err ] = await this.axios.get('check_release', {
      //   params: {
      //     name: 'livekit_server',
      //   },
      // })
      //   .then(({ data: { is_active: isActive } }) => ([ isActive, null ]))
      //   .catch(err => ([ null, err ]));
      const result = true;
      const err = null;

      if (err) {
        console.error(err);
        return EventBus.$emit('error', 'Ocurrio un error intente nuevamente');
      }

      if (result) {
        return this.$store.dispatch('dialerV2/startLiveKit', this.callList.id)
          .catch(() => {
            this.registeringNewInfra = false;
          });
      }

      // const [ result2, err2 ] = await this.axios.get('check_release', {
      //   params: {
      //     name: 'new_infra',
      //   },
      // })
      //   .then(({ data: { is_active: isActive } }) => ([ isActive, null ]))
      //   .catch(err => ([ null, err ]));
      const result2 = true;
      const err2 = null;

      if (err2) {
        console.error(err);
        return EventBus.$emit('error', 'Ocurrio un error intente nuevamente');
      }

      if (!result2) {
        this.registeringNewInfra = false;
        this.callCenterModal = true;
        return;
      }

      return this.$store.dispatch('dialerV2/startCallCenter', this.callList.id)
        .catch(() => {
          this.registeringNewInfra = false;
        });
    },
  },
  watch: {
    callCenterModal() {
      if (!this.callCenterModal) {
        this.disableSaveButton = false;
      }
    },
    'filters.date'() { // eslint-disable-line
      this.reloadStatus();
    },
    'filters.user_id'() { // eslint-disable-line
      this.reloadStatus();
    },
    'filters.status'() { // eslint-disable-line
      this.reloadStatus();
    },
  },
};
</script>

<style scoped>
small {
  color: rgba(0,0,0,.54);
}
.fixed >>> .list__tile__content {
  width: 250px;
}
.subheading {
  font-size: 16px !important;
  font-weight: 400;
  min-width: 400px;
  text-align: right;
}
.cursor-pointer {
  cursor: pointer;
  border-radius: 50%;
}
.cursor-pointer:hover {
  background-color: rgba(0,0,0,0.08);
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/Detail/Index.vue